import http from '../plugins/axios';

export async function get_parent_location(value) {
  const response = await http.get('g/TABLE', { params: value });
  return response.data;
}

export async function save_change_order_locations(input) {
  const response = await http.post('order/change-location', input);
  return response;
}


export async function force_change_table_free(payload) {
  const response = await http.post('table/force-available', payload);
  return response;
}

